import { Capacitor } from '@capacitor/core'

const IS_NATIVE = Capacitor.isNativePlatform()

const CURRENT_PLATFORM = Capacitor.getPlatform() as 'ios' | 'android' | 'web'

const SCHEMAS = {
  ios: 'solidsportapp://',
  android: 'https://'
}

const SOLID_SPORT_APP = {
  POSSIBLE_DOMAINS: ['solidsport.com', 'local.sportstage.se:3000'],
  get IS_CURRENT_DOMAIN() {
    return this.POSSIBLE_DOMAINS.includes(window.location.host)
  },
  get GET_DOMAIN() {
    return this.IS_CURRENT_DOMAIN ? window.location.host : undefined
  },
  get GET_URL() {
    const currentDomain = this.GET_DOMAIN || this.POSSIBLE_DOMAINS[0]
    if (CURRENT_PLATFORM === 'web') {
      // throw new Error(
      //   'SOLID_SPORT_APP : Dont use this on web platform, this is just for native platforms'
      // )
      console.error(
        'SOLID_SPORT_APP : Dont use this on web platform, this is just for native platforms'
      )
      return `https://${currentDomain}`
    }
    return `${SCHEMAS[CURRENT_PLATFORM]}${currentDomain}`
  }
}

export const NATIVE_APP_HELPER = {
  IS_NATIVE_PLATFORM: IS_NATIVE,
  GET_PLATFORM: CURRENT_PLATFORM,
  GET_HOST: window.location.host,
  GET_HOST_NAME: window.location.hostname,
  SCHEMAS: { ...SCHEMAS },
  SOLID_SPORT_APP: {
    ...SOLID_SPORT_APP
  }
} as const
